import { createFaasProcedureConfig } from './utils/createFaasProcedureConfig';

export default createFaasProcedureConfig('ReadFastlanePresentationData.v1');
